module.exports = __webpack_public_path__ + "static/icons/icon-skiresortsi-17c7605efb3b506c91c7a12848a33ad6.svg";